"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var baseViewModel_1 = require("./base/baseViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        $(".chip-search-books").on("click", function () {
            if (_this.app.canBeHandledByApp()) {
                try {
                    _this.app.getAppMobileHandler().handleSearchFilters();
                    return;
                }
                catch (ex) {
                    console.error(ex);
                }
            }
            _this.app.closePopup();
            _this.app.f7.popup("#findBookPopup");
        });
        var vm = this.app.createViewModel("searchPopup", {
            urlFunc: function (genres, format, form, params) {
                if (format !== "any") {
                    params.format = format;
                }
                if (form !== "any") {
                    params.form = form;
                }
                return "promo/black-friday/" + genres + "?" + $.param(params);
            },
            deafaultSotring: "random"
        });
        this.findBookPopupViewModel = vm;
        ko.applyBindings(this.findBookPopupViewModel, $("#findBookPopup")[0]);
        $("#fbp_access_filter").hide();
        vm.genres(options.genres);
        vm.format(options.format);
        vm.form(options.form);
        vm.exceptGenreIds(options.exceptGenreIds);
        vm.state(options.state);
        vm.series(options.series);
        vm.download(options.download);
        vm.lastUpdate(options.lastUpdate);
        vm.published(options.published);
        vm.duration(options.duration);
        vm.length(options.length);
        vm.sorting(options.sorting);
        vm.hideFinished(options.hideFinished);
        vm.favoriteFilter(options.favoriteFilter);
        vm.seriesOrder(options.seriesOrder);
        vm.usingNeuralNetworks(options.usingNeuralNetworks);
    }
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=blackFriday.js.map